import { type OrderDetailWithoutShuffling } from '@hungryroot/rest';
import { useGetOrders } from './useGetOrders';

export function useNextOrder(options?: { enabled?: boolean }) {
  const {
    data: upcomingOrders,
    isLoading,
    isFetching,
  } = useGetOrders({ time_bucket: 'upcoming', limit: 1 }, options);

  let order: OrderDetailWithoutShuffling | undefined = undefined;

  if (!isLoading && upcomingOrders?.results) {
    order = upcomingOrders.results[0];
  }

  return { isLoading, isFetching, order };
}
